import { render, staticRenderFns } from "./CompareBox.vue?vue&type=template&id=39e974bb&scoped=true"
import script from "./CompareBox.vue?vue&type=script&lang=js"
export * from "./CompareBox.vue?vue&type=script&lang=js"
import style0 from "./CompareBox.vue?vue&type=style&index=0&id=39e974bb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39e974bb",
  null
  
)

export default component.exports